import ObjectUtils from "../utils/ObjectUtils";
import { INDICATOR_MANAGEMENT_STORE, PROPERTY_NAME, PROPERTY_VALUE, TYPE_KEY } from "../common/constant";
import rest from "../common/rest";
import { clearMessages, createErrorMessages, messagesReceived } from "./message";
import { showDialog } from "./confirmDialog";

const REDUCER = "INDMGNT.";

const PROPERTY_CHANGED_ACTION = REDUCER + "PROPERTY_CHANGED_ACTION";
const RESET_STATE_ACTION = REDUCER + "RESET_STATE_ACTION";

export const ACTION_FIELDS = "actionFields";
export const RESULTS = "results";
export const INDICATORS = "indicators";
export const QUESTIONS = "questions";
export const LIBRARY_QUESTIONS = "libraryQuestions";

export const SELECTED_ACTION_FIELD = "selectedActionField";
export const SELECTED_RESULT = "selectedResult";

export const EDITED_ACTION_FIELD = "editedActionField";
export const EDITED_RESULT = "editedResult";
export const EDITED_INDICATOR = "editedIndicator";

export const INDICATOR_CODE_VALID = "indicatorCodeValid";

const initialState = {
  [ACTION_FIELDS]: [],
  [RESULTS]: [],
  [INDICATORS]: [],
  [QUESTIONS]: [],
  [LIBRARY_QUESTIONS]: [],
  [SELECTED_ACTION_FIELD]: undefined,
  [SELECTED_RESULT]: undefined,
  [EDITED_ACTION_FIELD]: undefined,
  [EDITED_RESULT]: undefined,
  [EDITED_INDICATOR]: undefined,
  [INDICATOR_CODE_VALID]: true
};

export default function reducer(state = initialState, action) {
  let newState;
  switch (action[TYPE_KEY]) {
    case PROPERTY_CHANGED_ACTION:
      newState = Object.assign({}, state, {
        [action[PROPERTY_NAME]]: action[PROPERTY_VALUE]
      });
      break;
    case RESET_STATE_ACTION:
      newState = { ...initialState };
      break;
    default:
      newState = Object.assign({}, state, {});
      break;
  }

  return newState;
}

export function resetState() {
  return (dispatch) => {
    dispatch({ [TYPE_KEY]: RESET_STATE_ACTION });
  };
}

export function loadActionFields() {
  return (dispatch) => {
    rest.doGet(`/admin/actionfields`).then((actionFields) => {
      dispatch(propertyChange(ACTION_FIELDS, actionFields));
    });
  };
}

export function saveActionField() {
  return (dispatch, getState) => {
    const editedActionField = getState()[INDICATOR_MANAGEMENT_STORE][EDITED_ACTION_FIELD];

    if (editedActionField.id) {
      rest
        .doPut(`/admin/actionfields/${editedActionField.id}`, JSON.stringify(editedActionField))
        .then((actionFields) => {
          dispatch(propertyChange(EDITED_ACTION_FIELD, undefined));
          dispatch(loadActionFields());
        });
    } else {
      rest.doPost(`/admin/actionfields`, JSON.stringify(editedActionField)).then((actionFields) => {
        dispatch(propertyChange(EDITED_ACTION_FIELD, undefined));
        dispatch(loadActionFields());
      });
    }
  };
}

export function saveResult() {
  return (dispatch, getState) => {
    const editedResult = getState()[INDICATOR_MANAGEMENT_STORE][EDITED_RESULT];

    const selectedActionField = getState()[INDICATOR_MANAGEMENT_STORE][SELECTED_ACTION_FIELD];

    if (editedResult.id) {
      rest.doPut(`/admin/results/${editedResult.id}`, JSON.stringify(editedResult)).then((actionFields) => {
        dispatch(propertyChange(EDITED_RESULT, undefined));
        dispatch(loadResults(selectedActionField));
      });
    } else {
      rest.doPost(`/admin/results`, JSON.stringify(editedResult)).then((actionFields) => {
        dispatch(propertyChange(EDITED_RESULT, undefined));
        dispatch(loadResults(selectedActionField));
      });
    }
  };
}

export function saveIndicator() {
  return (dispatch, getState) => {
    const editedIndicator = getState()[INDICATOR_MANAGEMENT_STORE][EDITED_INDICATOR];

    const selectedResult = getState()[INDICATOR_MANAGEMENT_STORE][SELECTED_RESULT];

    if (editedIndicator.id) {
      rest.doPut(`/admin/indicators/${editedIndicator.id}`, JSON.stringify(editedIndicator)).then((indicator) => {
        dispatch(propertyChange(EDITED_INDICATOR, undefined));
        dispatch(loadIndicators(selectedResult));
      });
    } else {
      rest.doPost(`/admin/indicators`, JSON.stringify(editedIndicator)).then((indicator) => {
        dispatch(propertyChange(EDITED_INDICATOR, undefined));
        dispatch(loadIndicators(selectedResult));
      });
    }
  };
}

export function loadAllData() {
  return (dispatch) => {
    dispatch(loadActionFields());
    dispatch(loadResults());
    dispatch(loadIndicators());
  };
}

export function loadResults(actionField) {
  return (dispatch) => {
    const urlParams = actionField ? `actionFieldId=${actionField.id}` : "";

    rest.doGet(`/admin/results?${urlParams}`).then((results) => {
      dispatch(propertyChange(RESULTS, results));
    });
  };
}

export function loadIndicators(result) {
  return (dispatch) => {
    const urlParams = result ? `resultId=${result.id}` : "";

    rest.doGet(`/admin/indicators?${urlParams}`).then((response) => {
      // rest resource methods return different formats
      const indicatorList = response.indicators ? response.indicators : response;

      dispatch(propertyChange(INDICATORS, indicatorList));
      result && dispatch(loadIndicatorQuestions(indicatorList));
    });
  };
}

export function loadLibraryQuestions(result) {
  return (dispatch) => {
    rest.doGet(`/admin/library/questions/`).then((response) => {
      // rest resource methods return different formats
      const indicatorList = response.questions ? response.questions : response;

      dispatch(propertyChange(LIBRARY_QUESTIONS, indicatorList));
    });
  };
}

export function loadIndicatorQuestions(indicators) {
  return (dispatch) => {
    if (indicators) {
      const indicatorIds = indicators.map((i) => (i.id ? i.id : i.identifier)).join(",");

      rest.doGet(`/admin/library/questions/?indicatorIds=${indicatorIds}`).then((questions) => {
        dispatch(propertyChange(QUESTIONS, questions));
      });
    } else {
      rest.doGet(`/admin/library/questions/`).then((response) => {
        dispatch(propertyChange(QUESTIONS, response.questions));
      });
    }
  };
}

export function deleteActionField(actionFieldId) {
  if (!actionFieldId) {
    return;
  }

  return (dispatch) => {
    dispatch(
      showDialog(
        actionFieldId,
        (actionFieldId) => {
          rest
            .doDelete(`/admin/actionfields/${actionFieldId}`)
            .then((questions) => {
              dispatch(loadActionFields());
            })
            .catch((response) => {
              if (response.status === 412) {
                dispatch(
                  messagesReceived(createErrorMessages("indicator.management.delete.action.field.not.possible"))
                );
              }
            });
        },
        "",
        "indicator.management.confirm.delete.action.field",
        "confirmDialog.confirmLabel",
        "confirmDialog.dismissLabel"
      )
    );
  };
}

export function deleteResult(resultId) {
  if (!resultId) {
    return;
  }

  return (dispatch, getState) => {
    dispatch(
      showDialog(
        resultId,
        (resultId) => {
          rest
            .doDelete(`/admin/results/${resultId}`)
            .then((questions) => {
              const selectedActionField = getState()[INDICATOR_MANAGEMENT_STORE][SELECTED_ACTION_FIELD];

              dispatch(loadResults(selectedActionField));
            })
            .catch((response) => {
              if (response.status === 412) {
                dispatch(messagesReceived(createErrorMessages("indicator.management.delete.result.not.possible")));
              }
            });
        },
        "",
        "indicator.management.confirm.delete.result",
        "confirmDialog.confirmLabel",
        "confirmDialog.dismissLabel"
      )
    );
  };
}

export function deleteIndicator(indicatorId) {
  if (!indicatorId) {
    return;
  }

  return (dispatch, getState) => {
    dispatch(
      showDialog(
        indicatorId,
        (indicatorId) => {
          rest
            .doDelete(`/admin/indicators/${indicatorId}`)
            .then((questions) => {
              const selectedResult = getState()[INDICATOR_MANAGEMENT_STORE][SELECTED_RESULT];

              dispatch(loadIndicators(selectedResult));
            })
            .catch((response) => {
              if (response.status === 412) {
                dispatch(messagesReceived(createErrorMessages("indicator.management.delete.indicator.not.possible")));
              }
            });
        },
        "",
        "indicator.management.confirm.delete.indicator",
        "confirmDialog.confirmLabel",
        "confirmDialog.dismissLabel"
      )
    );
  };
}

export function propertyChange(propertyName, propertyValue) {
  return {
    [TYPE_KEY]: PROPERTY_CHANGED_ACTION,
    [PROPERTY_NAME]: propertyName,
    [PROPERTY_VALUE]: propertyValue
  };
}

export function selectedActionFieldChange(selectedActionField) {
  return (dispatch) => {
    dispatch(clearMessages());
    dispatch(propertyChange(SELECTED_ACTION_FIELD, selectedActionField));
    dispatch(propertyChange(SELECTED_RESULT, undefined));
    if (selectedActionField) {
      dispatch(loadResults(selectedActionField));
    }
  };
}

export function selectedResultChange(result) {
  return (dispatch) => {
    dispatch(clearMessages());
    dispatch(propertyChange(SELECTED_RESULT, result));
    if (result) {
      dispatch(loadIndicators(result));
    }
  };
}

export function editActionField(actionField) {
  return (dispatch) => {
    dispatch(clearMessages());
    dispatch(propertyChange(EDITED_ACTION_FIELD, actionField ? ObjectUtils.deepClone(actionField) : undefined));
  };
}

export function editResult(activeElement) {
  return (dispatch) => {
    dispatch(clearMessages());
    dispatch(propertyChange(EDITED_RESULT, activeElement ? ObjectUtils.deepClone(activeElement) : undefined));
  };
}

export function editIndicator(indicator) {
  return (dispatch) => {
    dispatch(clearMessages());
    dispatch(propertyChange(EDITED_INDICATOR, indicator ? ObjectUtils.deepClone(indicator) : undefined));
    dispatch(propertyChange(INDICATOR_CODE_VALID, true));

    // do validation only for new indicators
    if (indicator && !indicator.id && indicator.indicatorId) {
      rest
        .doGet(`/admin/indicators/?indicatorId=${indicator.indicatorId}`)
        .then((indicator) => {
          dispatch(propertyChange(INDICATOR_CODE_VALID, false));
        })
        .catch((r) => {
          r.status === 404 && dispatch(propertyChange(INDICATOR_CODE_VALID, true));
        });
    }
  };
}

export function createActionField() {
  return (dispatch) => {
    dispatch(
      propertyChange(EDITED_ACTION_FIELD, {
        name: {
          de: "",
          en: ""
        }
      })
    );
  };
}

export function createResult() {
  return (dispatch, getState) => {
    const selectedActionField = getState()[INDICATOR_MANAGEMENT_STORE][SELECTED_ACTION_FIELD];

    if (!selectedActionField) {
      return;
    }

    dispatch(
      propertyChange(EDITED_RESULT, {
        name: {
          de: "",
          en: ""
        },
        description: {
          de: "",
          en: ""
        },
        actionFields: [selectedActionField]
      })
    );
  };
}

export function createIndicator() {
  return (dispatch, getState) => {
    const selectedResult = getState()[INDICATOR_MANAGEMENT_STORE][SELECTED_RESULT];

    if (!selectedResult) {
      return;
    }

    dispatch(propertyChange(INDICATOR_CODE_VALID, true));
    dispatch(
      propertyChange(EDITED_INDICATOR, {
        name: {
          de: "",
          en: ""
        },
        shortName: {
          de: "",
          en: ""
        },
        longName: {
          de: "",
          en: ""
        },
        result: selectedResult
      })
    );
  };
}
